import AppView from "@/views/AppView";
import OrganizationRouter from "@/router/organization.router";

export default {
  path: "/",
  name: "app",
  component: AppView,
  redirect: { name: "app.organizations" },
  children: [OrganizationRouter],
};
